import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import URL_PATTERNS from "../../../urls";
import { isLoggedIn } from "../../../helpers/auth";

/**
 * On native app launch, redirects the user to the right entry route
 * based on their auth state. Web builds are unaffected.
 *
 * - Logged in → MY_DASHBOARD
 * - Not logged in → WELCOME
 *
 * Only fires when the app boots at a "root" path ("/", "/au/", "/uk/").
 * If the user reloads on a specific page — e.g. we trigger a hard
 * reload to /uk/login/ from the welcome screen to switch Apollo to the
 * UK endpoint — we don't want to bounce them back to /welcome/.
 */
const ROOT_ENTRY_PATH_RE = /^\/(?:[a-z]{2}\/?)?$/;

const NativeEntryRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const path = history.location.pathname;
    if (!ROOT_ENTRY_PATH_RE.test(path)) return;

    const target = isLoggedIn() ? URL_PATTERNS.MY_DASHBOARD : URL_PATTERNS.WELCOME;
    history.replace(target);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default NativeEntryRedirect;
